<div class="container">
  <h1>Hello there</h1>

  <p>
    Won't you please <a routerLink="/login">sign in</a> or
    <a routerLink="/register">register</a>?
  </p>
</div>
